import { Link } from "react-router-dom";
import { allCategories } from "@/utils/community";

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-secondary-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg brand-gradient flex items-center justify-center text-background-50">
                <i className="ri-chat-smile-3-fill text-lg" />
              </span>
              <span className="font-logo text-xl text-background-50">香蕉社区</span>
            </div>
            <p className="text-sm text-secondary-300 leading-relaxed">
              一个围绕多元交流互动展开的社区平台，涵盖兴趣分享、生活日常与专业讨论，帮你结识志同道合的朋友。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {[
                { icon: "ri-wechat-line", label: "微信" },
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-zhihu-line", label: "知乎" },
                { icon: "ri-mail-line", label: "邮箱" },
              ].map((s) => (
                <span
                  key={s.icon}
                  title={s.label}
                  className="w-9 h-9 rounded-full bg-secondary-900 text-secondary-200 flex items-center justify-center hover:bg-primary-500 hover:text-foreground-950 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-base`} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">话题分类</h3>
            <ul className="space-y-2.5">
              {allCategories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className="text-sm text-secondary-300 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">
                  站内搜索
                </Link>
              </li>
              <li>
                <Link to="/post" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">
                  发布内容
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">关于社区</h3>
            <p className="text-sm text-secondary-300 leading-relaxed mb-4">
              我们相信，每一次真诚的分享，都会让陌生的人彼此靠近一点。
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-1.5 h-10 px-4 rounded-full bg-primary-500 hover:bg-primary-600 text-foreground-950 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-send-plane-line" />
              提交反馈
            </Link>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            © 2025 香蕉社区 BANANA COMMUNITY. 本平台内容均为演示示例，仅供展示使用。
          </p>
          <div className="flex items-center gap-5">
            <Link to="/about" className="text-xs text-secondary-400 hover:text-primary-400 transition-colors">
              服务条款
            </Link>
            <Link to="/about" className="text-xs text-secondary-400 hover:text-primary-400 transition-colors">
              隐私政策
            </Link>
            <Link to="/" className="text-xs text-secondary-400 hover:text-primary-400 transition-colors">
              返回首页
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}